export default "__VITE_ASSET__d85c414c__"